// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".password-input[data-v-bec831ba]{position:relative}.password-input .icon-reveal[data-v-bec831ba]{--text-opacity:1;color:#c7d6dc;color:rgba(199,214,220,var(--text-opacity));position:absolute;cursor:pointer;-webkit-transition:all .2s;transition:all .2s;top:50%;right:1.6rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.password-input .icon-reveal[data-v-bec831ba]:hover{--text-opacity:1;color:#8a9ba5;color:rgba(138,155,165,var(--text-opacity))}", ""]);
// Exports
module.exports = exports;
